import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Stack,
  FormControlLabel,
  FormGroup,
  CircularProgress,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import TabPanel from "../../components/TabPanel";
import PaymentRelationship from "./payment/relationship";
import PaymentCommunication from "./payment/communication";
import PaymentSystemInformation from "./payment/systemInformation";
import PaymentCustom from "./payment/custom";
import PaymentMethod from "./payment/payment-method";
import PaymentApply from "./payment/apply";
import useSnackbar from "../../hooks/useSnackbar";
import { useSelector } from "react-redux";
import { getTransactionEft,getTransactionCustomerPaymentDetail } from "../../api/transaction-type";
import { compose } from "redux";
import PaymentEft from "./payment/eft";
export default function TransactionTypePayment() {
  const params = useParams();
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
  /*----------------End Tabs-----------------*/
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const [eftData, seteftData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (user.token && tabIndex === 6) {
      getTransactionEftData();
    }

    if(user.token){
      getTransactionDocDetailTableData()
    }
  }, []);

  async function getTransactionEftData() {
    try {
      const { data } = await getTransactionEft(user.token, {
        id: params.docNo,
      });
      seteftData(data.data.data);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }

  async function getTransactionDocDetailTableData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCustomerPaymentDetail(user.token, {
        tranid: params.docNo,
        limit:1,
        offset:0
        // type: pageDetail.path,
      });
      setLoading(false);
      setData(data.data)
      setRowData(data.data.details);

      return {
        rows: data.data.details,
        total: data.data.Detailstotal,
        error: false,
      };
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
   return loading ? (
      <>
       <Typography component="h4" fontWeight={500} className="pageTitle">
       Payment
        </Typography>
        <Box className="viewBox">
          <Box
            className="headerItems"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            pb={2}
          >
            <Typography component="h5" fontWeight={500} className="pageHeading1">
              Primary Information
            </Typography>
            <Link to={"/transaction-type/" + params.slug}>
              <Button size="small" variant="contained" className="backBtn">
                Go Back
              </Button>
            </Link>
          </Box>
          <Box className="viewDetilsBox">
            <Grid container className="mb-2">
              <Grid item xs={12}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress></CircularProgress>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box className="viewBox">
          <Box
            className="headerItems"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            pb={2}
          >
            <Typography component="h5" fontWeight={500} className="pageHeading1">
            PAYMENT INFORMATION 
            </Typography>
          </Box>
          <Box className="viewDetilsBox">
            <Grid container className="mb-2">
              <Grid item xs={12}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress></CircularProgress>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box className="viewBox">
          <Box
            className="headerItems"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            pb={2}
          >
            <Typography component="h5" fontWeight={500} className="pageHeading1">
             Classification
            </Typography>
          </Box>
          <Box className="viewDetilsBox">
            <Grid container className="mb-2">
              <Grid item xs={12}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress></CircularProgress>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </>
    ) : (
    <>
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Payment
      </Typography>
      <Typography component="p" sx={{ mb: 2 }}>
        <span className="para-no"> <strong>{rowData[0]?.payment_no}</strong></span>{" "}
        <Button className="blue-button" size="small" sx={{ ml: 1 }}>
         {rowData[0]?.status}
        </Button>
      </Typography>
      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
    
            <Box className="viewDetilsBox"  >
            <>
            {
          rowData?.map((el,i)=>(
              <Grid container className="mb-2" key={i}>
                <Grid item xs={12} sm={6} md={8}>
                  <Grid container className="mb-2">
                    <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel">CUSTOMER</p>
                      <p className="tFormName">{el.customer}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel">A/R ACCOUNT</p>
                      <p className="tFormName">{el.araccount}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel">PAYMENT #</p>
                      <p className="tFormName">{el.payment_no}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel">ACCOUNT</p>
                      <p className="tFormName">{el.account}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel">BALANCE </p>
                      <p className="tFormName">{el.balance}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel"> PENDING </p>
                      <p className="tFormName">{el.pending}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel"> CONSOLIDATED BALANCE</p>
                      <p className="tFormName">{el.consolidated_balance}</p>
                    </Grid>
                    {/* <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">PC/PROJECT</p>
                  <p className="tFormName">{rowData.pc_project}</p>
                </Grid> */}
                    <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel">DATE</p>
                      <p className="tFormName">{el.date}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel">CURRENCY</p>
                      <p className="tFormName">{el.currency}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel">POSTING PERIOD</p>
                      <p className="tFormName">{el.posting_period}</p>
                    </Grid>
                    {/* <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <FormGroup>
                        <FormControlLabel
                          control={<checkbox  disabled/>}
                          label="PAYMENT HOLD"
                        />
                      </FormGroup>
                    </Grid> */}

                    <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel">EXCHANGE RATE</p>
                      <p className="tFormName">{el.exchangerate}</p>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} className="m-b-10">
                      <p className="tFormlabel">MEMO</p>
                      <p className="tFormName">{el.memo}</p>
                    </Grid>
                 
                  </Grid>
                </Grid>
                   {/* -----------Summary Box------------- */}
                   <Grid item xs={12} sm={6} md={4}>
                  <Box className="viewBox">
                    <Box
                      className="headerItemsSB"
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      pb={2}
                    >
                      <Typography
                        component="h5"
                        fontWeight={500}
                        className="pageHeading1"
                      >
                        Summary
                      </Typography>
                    </Box>
                    <Box className="viewDetilsBox1">
                      <Grid container>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormlabel">APPLIED</p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormtotal">{el?.applied}</p>
                        </Grid>
                       
                      </Grid>
                      <Divider />
                      <Grid container sx={{ mt: 1 }}>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormlabel">UNAPPLIED</p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormtotal">{el?.unapplied}</p>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Grid>
                {/* -----------End Summary Box------------- */}
            
               </Grid>
                  ))
                }
            </>
          </Box>
      </Box>

{/*Payment information */}
<Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
        PAYMENT INFORMATION
          </Typography>
        </Box>
      <Box className="viewDetilsBox" >
            <>
          {  rowData?.map((el,i)=>(
              <Grid container className="mb-2" key={i}>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">PAYMENT METHOD</p>
                  <p className="tFormName">{el.paymentmethod}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={8} className="m-b-10">
                  <p className="tFormlabel">UNAPPLIED PAYMENT PC/PROJECT</p>
                  <p className="tFormName">{el.unappliedpayment_pc_project}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">CHECK/WIRE NUMBER</p>
                  <p className="tFormName">{el.checkwirenumber}</p>
                </Grid>
                
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">BILL TO ADDRESS</p>
                  <p className="tFormName">{el.billtoaddress}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">PC/PROJECT</p>
                  <p className="tFormName">{el.pc_project}</p>
                </Grid>
                </Grid>
              ))
            }
            </>
          </Box>
          </Box>

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
          Classification
          </Typography>
        </Box>
        {
          rowData?.map((el,i)=>(
            <Box className="viewDetilsBox" key={i}>
            <>
              <Grid container className="mb-2">
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">SUBSIDIARY</p>
                  <p className="tFormName">{el.subsidiary}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={8} className="m-b-10">
                  <p className="tFormlabel">SERVICE LINE</p>
                  <p className="tFormName">{el.serviceline}</p>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">DEPARTMENT</p>
                  <p className="tFormName">{el.department}</p>
                </Grid>
                
                <Grid item xs={12} sm={6} md={4} className="m-b-10">
                  <p className="tFormlabel">LOCATION</p>
                  <p className="tFormName">{el.location}</p>
                </Grid>
              </Grid>
            </>
          </Box>
          ))
        }
      
      </Box>
      <Box>
        <Box
          className="viewBox "
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Apply" />
            <Tab label="Payment Method" />
            <Tab label="Relationships" />
            <Tab label="Communication" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
          </Tabs>
          {/*------------Apply------------*/}
          <TabPanel value={tabIndex} index={0}>
            <PaymentApply />
          </TabPanel>
             {/*------------Payment Method------------*/}
             <TabPanel value={tabIndex} index={1}>
           {tabIndex === 1 && <PaymentMethod />}
          </TabPanel>
          {/*------------Relationships------------*/}
          <TabPanel value={tabIndex} index={2}>
           {tabIndex === 2 && <PaymentRelationship />}
          </TabPanel>
          {/*------------Communication------------*/}
          <TabPanel value={tabIndex} index={3}>
           {tabIndex === 3 && <PaymentCommunication />}
          </TabPanel>

          {/*-------------System Information-----------*/}
          <TabPanel value={tabIndex} index={4}>
            { tabIndex === 4 &&<PaymentSystemInformation />}
          </TabPanel>
          {/*-------------CUSTOM-----------*/}
          <TabPanel value={tabIndex} index={5}>
            
            { tabIndex === 5 &&<PaymentCustom />}

          </TabPanel>
          {/*------------EFT-----------*/}
          <TabPanel value={tabIndex} index={6}>
            <Box className="viewDetilsBox">
            { tabIndex === 6 &&<PaymentEft />}

            </Box>
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
